import Vue from 'vue';
import * as queryString from 'query-string';

export class SharedService {
    static truncateText(text, length) {
        if (!text) {
            return '';
        }
        return (text.length > length && length !== 0) ?
            text.slice(0, length).trim() + '...' :
            text;
    }

    static httpGetElements(url) {
        return Vue.http.get(url)
            .then((response) => {
                return response.body.results;
            },
                (err) => {
                    // eslint-disable-next-line
                    console.error('Err', err);
                })
            .catch((e) => {
                // eslint-disable-next-line
                console.error('Caught', e);
            });
    }

    static httpPost(url, formData) {
        url += queryString.stringify(formData);
        return Vue.http.post(url, {})
            .then((response) => {
                return response;
            },
            (err) => {
                return err;
            })
            .catch((e) => {
                return e;
            });
    }



    static httpPostCrypto2(url, formData) {
     
       
        var newForm = formData;

        if(formData.password){
            const txt2 = formData.password;
            const b643 = window.btoa(txt2);
            newForm.password = b643;
        }
        url += queryString.stringify(newForm);



        return Vue.http.post(url, {})
            .then((response) => {
                return response;
            },
                (err) => {
                    return err;
                })
            .catch((e) => {
                return e;
            });
    }




    static httpPostCrypto(url, formData) {
     
       const txt2 = formData.clauVisor;
        const b643 = window.btoa(txt2);
        const pass = window.btoa(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
        url += "&businessId=" + formData.businessId +"&clauVisor="+pass+"&mapaTop="+b643;
        return Vue.http.post(url, {})
            .then((response) => {
                return response;
            },
            (err) => {
                return err;
            })
            .catch((e) => {
                return e;
            });
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/sharedService.js